export const FEEDBACK_TYPES = [{
  name: 'Data Related Error',
  value: 'dbi_detail_data_error'
}, {
  name: 'True Data',
  value: 'dbi_detail_true_data'
}, {
  name: 'Basic Information Error',
  value: 'dbi_detail_basic_information_error'
},
{
  name: 'Feature Suggestion',
  value: 'dbi_detail_feature_suggestion'
}, {
  name: 'Others',
  value: 'dbi_others'
}];

export const METRICLISTOPTIONSCOMBINE = [
  {
    text: 'Lifetime Revenue',
    value: 'Lifetime Revenue'
  },
  {
    text: 'Lifetime Sales Units',
    value: 'Lifetime Sales Units'
  },
  {
    text: 'Revenue',
    value: 'Revenue'
  },
  {
    text: 'Sales Units',
    value: 'Sales Units'
  },
  {
    text: 'MAU',
    value: 'MAU'
  },
  {
    text: 'DAU',
    value: 'DAU'
  },
  {
    text: 'CCU',
    value: 'CCU'
  },
  {
    text: 'Lifetime Players',
    value: 'Lifetime Players'
  },
];

export const METRICLISTOPTIONSMOBILE = [
  {
    text: 'Lifetime Revenue',
    value: 'Lifetime Revenue'
  },
  {
    text: 'Lifetime Downloads',
    value: 'Lifetime Downloads'
  },
  {
    text: 'Revenue',
    value: 'Revenue'
  },
  {
    text: 'Downloads',
    value: 'Downloads'
  },
  {
    text: 'MAU',
    value: 'MAU'
  },
  {
    text: 'DAU',
    value: 'DAU'
  },
  {
    text: 'Lifetime Players',
    value: 'Lifetime Players'
  },
];

// export const METRICLISTOPTIONSCOMBINE = [
//   ...METRICLISTOPTIONS,
// ];

// export const METRICLISTOPTIONSMOBILE = [
//   ...METRICLISTOPTIONS,
//   ...METRICLISTOPTIONSDOWNLOAD,
// ];

export const FEEDBACKSOURCEOPTIONS = [
  {
    text: 'Public Data',
    labelkey: 'dbi_feedback_public_data',
    value: 'Public Data',
  },
  {
    text: 'Expert Knowledge',
    labelkey: 'dbi_feedback_expert_knowledge',
    value: 'Expert Knowledge',
  },
  {
    text: 'Financial Reports',
    labelkey: 'dbi_feedback_financial_reports',
    value: 'Financial Reports',
  },
  {
    text: 'Others',
    labelkey: 'dbi_feedback_public_others',
    value: 'Others',
  },
];
